<template>
  <div>
    <v-app
      :style="{
        'background-color':
          env.NODE_ENV !== 'production' ? 'rgb(245,222,179)' : '#fff',
      }">
      <v-container>
        <router-view></router-view>
      </v-container>
    </v-app>
  </div>
</template>
<script>
export default {
  data() {
    return {
      env: process.env,
    };
  },
};
</script>
